"use strict";

module.exports = require('./fhir');